import React from 'react';
import {View} from 'react-native';

import Text from '../../themed/Text';

export default function AccessYourCard() {
  return (
    <View style={{flexDirection: 'row'}}>
      <Text variant="body2">
        Access your card anytime when you add it to your digital wallet, or
        access the rewards page in the app
      </Text>
    </View>
  );
}
